import { render } from "./MultipleSelectView.vue?vue&type=template&id=80ddf662"
import script from "./MultipleSelectView.vue?vue&type=script&lang=js"
export * from "./MultipleSelectView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__